/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ticket } from '../../models/ticket';
import { TicketRecategorize } from '../../models/ticket-recategorize';

export interface ApiTicketItemIdRecategorizePut$Params {
  item_id: number;
      body: TicketRecategorize
}

export function apiTicketItemIdRecategorizePut(http: HttpClient, rootUrl: string, params: ApiTicketItemIdRecategorizePut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdRecategorizePut.PATH, 'put');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ticket>;
    })
  );
}

apiTicketItemIdRecategorizePut.PATH = '/api/ticket/{item_id}/recategorize';
